import React from 'react';
import PropTypes from 'prop-types';

import { bem } from 'helpers/class-name';

import './StatsCard.scss';

const { block, element } = bem('stats-card');

export const statsCardElement = element;

const StatsCard = ({ className, dataCypress, footer, label, value }) => (
  <div className={block(null, className)} data-cypress={dataCypress}>
    <div className={element('label')}>{label}</div>
    <div className={element('value')}>{value}</div>
    {footer ? <div className={element('footer')}>{footer}</div> : null}
  </div>
);

StatsCard.propTypes = {
  className: PropTypes.string,
  dataCypress: PropTypes.string,
  footer: PropTypes.node,
  label: PropTypes.node.isRequired,
  value: PropTypes.node.isRequired,
};

export default StatsCard;
